module.exports = __webpack_public_path__ + "8b493e03bf2cf901ccaff2f02c9345a8.svg";